/**
 * 부고 도메인 공통 헬퍼
 * (담당 범위인 src/components/obituary 안에 두어 obituary 페이지/컴포넌트 전반에서 재사용)
 */

// 오늘 날짜(yyyy-MM-dd) - input[type=date] max 값 용
export const todayISO = () => {
  const d = new Date();
  const off = d.getTimezoneOffset();
  return new Date(d.getTime() - off * 60000).toISOString().slice(0, 10);
};

// 자정 기준으로 날짜 차이(일) 계산: 발인일 - 오늘
export const getDaysUntil = (dateStr) => {
  if (!dateStr) return null;
  const target = new Date(dateStr);
  if (isNaN(target.getTime())) return null;
  const t = new Date(target.getFullYear(), target.getMonth(), target.getDate());
  const now = new Date();
  const n = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((t - n) / (1000 * 60 * 60 * 24));
};

/**
 * 발인 D-day 정보 반환
 * @returns {{label: string, tone: 'urgent'|'soon'|'normal'|'done'}}
 */
export const getDepartureDday = (departureDate) => {
  const days = getDaysUntil(departureDate);
  if (days === null) return null;

  if (days < 0) {
    return { label: '영면하셨습니다', tone: 'done' };
  }
  if (days === 0) {
    return { label: '오늘 발인', tone: 'urgent' };
  }
  return {
    label: `발인 D-${days}`,
    tone: days <= 1 ? 'urgent' : days <= 3 ? 'soon' : 'normal',
  };
};

// 톤 → Tailwind 클래스 매핑 (테마 토큰 기반)
export const ddayToneClass = (tone) => {
  switch (tone) {
    case 'urgent':
      return 'bg-red-100 text-red-700 border border-red-200';
    case 'soon':
      return 'bg-amber-100 text-amber-700 border border-amber-200';
    case 'done':
      return 'bg-accent-100 text-accent-600 border border-accent-200';
    default:
      return 'bg-primary-50 text-primary-700 border border-primary-100';
  }
};

// 전화번호 자동 하이픈 (입력 중 사용)
export const autoHyphenPhone = (value) => {
  const digits = (value || '').replace(/\D/g, '').slice(0, 11);
  if (digits.length < 4) return digits;
  if (digits.length < 8) return digits.replace(/(\d{3})(\d+)/, '$1-$2');
  return digits.replace(/(\d{3})(\d{4})(\d+)/, '$1-$2-$3');
};

// 클립보드 복사 (구형 브라우저 폴백 포함)
export const copyToClipboard = async (text) => {
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (e) {
    // fallthrough to fallback
  }
  try {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    document.body.appendChild(textArea);
    textArea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textArea);
    return ok;
  } catch (e) {
    return false;
  }
};
